import { Car16, Walk16 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { UndergroundIcon } from '../../common/components/underground_icon';
import { UndergroundItem } from '../../components/GeoRedesigned/UndergroundItem';
import { UndergroundList } from '../../components/GeoRedesigned/UndergroundList';
import { regionIdSelector } from '../../selectors/offerData/geo/regionIdSelector';
import { undergroundsSelector } from '../../selectors/offerData/geo/undergroundsSelector';
import { isDefined, PREMIUM_REGIONS_IDS } from '../../utils';
import { getConstructionInfo } from '../../utils/formatters';

export const UndergroundsContainer = () => {
  const regionId = useSelector(regionIdSelector);
  const undergrounds = useSelector(undergroundsSelector);
  const size = PREMIUM_REGIONS_IDS.includes(regionId) ? 17 : 10;

  if (!undergrounds) {
    return null;
  }

  return (
    <UndergroundList>
      {undergrounds.map(underground => {
        const { underConstruction, lineColor, name, url } = underground;
        const constructionInfo = getConstructionInfo(underground);
        const travelTime = isDefined(underground.travelTime) ? `${underground.travelTime || '<1'} мин.` : null;
        const travelType = underground.travelType === 'walk' ? <Walk16 /> : <Car16 />;

        return (
          <UndergroundItem
            key={`underground_${name}`}
            icon={<UndergroundIcon width={size} height={size} color={`#${lineColor}`} regionId={regionId} />}
            underConstruction={!!underConstruction}
            undergroundName={name}
            undergroundUrl={url}
            constructionInfo={constructionInfo}
            travelType={travelType}
            travelTime={travelTime}
          />
        );
      })}
    </UndergroundList>
  );
};
